// F5 + R-29: whether this browser's person is in a group, without loading the groups code. Browse checks it on every card
// (the Add to <group> offer and its copy load only when it is true), so the first download stays as small as before groups.
export const IN_GROUP = 'mg_in_group'
export function inSomeGroup(): boolean {
  try { return localStorage.getItem(IN_GROUP) === '1' } catch { return false }
}
